export const cEstadoNota = {
    APROBADO: 14,
    REPROBADO: 15
}